/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferBatchesControllerListBatchesQueryResponse, TransferBatchesControllerListBatchesQueryParams, TransferBatchesControllerListBatches401, TransferBatchesControllerListBatches403 } from "../../models/transferBatchesController/TransferBatchesControllerListBatches";

function getTransferBatchesControllerListBatchesUrl() {
  const res = { method: 'GET', url: `/api/v1/transfer-batches` as const }  
  return res
}

/**
 * @summary List all transfer batches
 * {@link /api/v1/transfer-batches}
 */
export async function transferBatchesControllerListBatches(params?: TransferBatchesControllerListBatchesQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransferBatchesControllerListBatchesQueryResponse, ResponseErrorConfig<TransferBatchesControllerListBatches401 | TransferBatchesControllerListBatches403>, unknown>({ method : "GET", url : getTransferBatchesControllerListBatchesUrl().url.toString(), params, ... requestConfig })  
  return res.data
}